import { render, staticRenderFns } from "./contestFeedbackForm.html?vue&type=template&id=771874e1&scoped=true&external"
import script from "./contestFeedbackForm.js?vue&type=script&lang=js&external"
export * from "./contestFeedbackForm.js?vue&type=script&lang=js&external"
import style0 from "./contestFeedbackForm.scss?vue&type=style&index=0&id=771874e1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771874e1",
  null
  
)

export default component.exports